<template>
  <div class="StudentReports">

    <h1 class="m-label m-label-custom">対象</h1>

    <!-- <div class="index&#45;box" @scroll="offset"> -->
      <table-c>

        <tr-c slot="tr-th">
          <th-c @click.native='sort("id")'>ID</th-c>
          <th-c @click.native='sort("student_id")'>student_id</th-c>
          <th-c @click.native='sort("student_name")'>生徒</th-c>
          <th-c @click.native='sort("student_kana")'>せいと</th-c>
          <th-c @click.native='sort("tutor_id")'>tutor_id</th-c>
          <th-c @click.native='sort("tutor_name")'>先生</th-c>
          <th-c @click.native='sort("tutor_kana")'>せんせい</th-c>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in orderedStudent_tutors" :key="index.id" class="tr_hover" v-bind:class="{ 'list-edit': list.id == edit_id.edit_id }">

          <td-c class="clicked">{{list.id}}</td-c>
          <td-c class="clicked">{{list.student_id}}</td-c>
          <td-c class="clicked">{{student.f_name}} {{student.l_name}}</td-c>
          <td-c class="clicked">{{student.f_name_kana}} {{student.l_name_kana}}</td-c>
          <td-c class="clicked">{{list.tutor_id}}</td-c>
          <template v-if="list.tutor">
            <td-c class="clicked">{{list.tutor.f_name}} {{list.tutor.l_name}}</td-c>
            <td-c class="clicked">{{list.tutor.f_name_kana}} {{list.tutor.l_name_kana}}</td-c>
          </template>
          <template v-else>
            <td-c></td-c>
            <td-c></td-c>
          </template>

        </tr-c>
      </table-c>
    <!-- </div> -->

    <h1 class="m-label m-label-custom">報告書</h1>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")' v-ripple>ID</th-c></template>
          <template v-if="student_tutor_id"><th-c @click.native='sort("student_tutor_id")' v-ripple>student_tutor_id</th-c></template>
          <template v-if="student_name"><th-c @click.native='sort("student_name")' v-ripple>生徒</th-c></template>
          <template v-if="student_kana"><th-c @click.native='sort("student_kana")' v-ripple>せいと</th-c></template>
          <template v-if="tutor_name"><th-c @click.native='sort("tutor_name")' v-ripple>先生</th-c></template>
          <template v-if="tutor_kana"><th-c @click.native='sort("tutor_kana")' v-ripple>せんせい</th-c></template>
          <template v-if="month"><th-c @click.native='sort("month")' v-ripple>何月分</th-c></template>
          <template v-if="state"><th-c @click.native='sort("state")' v-ripple>現状</th-c></template>
          <template v-if="note"><th-c @click.native='sort("note")' v-ripple>備考</th-c></template>
          <template v-if="file_name"><th-c @click.native='sort("file_name")' v-ripple>ファイル名</th-c></template>
          <template v-if="points_english"><th-c @click.native='sort("points_english")' v-ripple>英語</th-c></template>
          <template v-if="points_mathematics"><th-c @click.native='sort("points_mathematics")' v-ripple>数学</th-c></template>
          <template v-if="points_japanese"><th-c @click.native='sort("points_japanese")' v-ripple>国語</th-c></template>
          <template v-if="points_science"><th-c @click.native='sort("points_science")' v-ripple>理科</th-c></template>
          <template v-if="points_socialstudies"><th-c @click.native='sort("points_socialstudies")' v-ripple>社会</th-c></template>
          <template v-if="file"><th-c @click.native='sort("file")' v-ripple>ファイル</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")' v-ripple>User</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")' v-ripple>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in filteredReports" :key="index.id" class="tr_hover" v-bind:class="{ 'list-edit': list.id == edit_id.edit_id }">

          <template v-if="list.id == edit_id.edit_id">

            <td-c @click.native="cancelReport(list)" class="del">戻る</td-c>
            <td-c @click.native="patchReport(list)" class="del">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="student_tutor_id"><td-c>{{list.student_tutor_id}}</td-c></template>
            <template v-if="student_name"><td-c>{{list.student_tutor.student.f_name}} {{list.student_tutor.student.l_name}}</td-c></template>
            <template v-if="student_kana"><td-c>{{list.student_tutor.student.f_name_kana}} {{list.student_tutor.student.l_name_kana}}</td-c></template>
            <template v-if="list.tutor">
              <template v-if="tutor_name"><td-c>{{list.student_tutor.tutor.f_name}} {{list.student_tutor.tutor.l_name}}</td-c></template>
              <template v-if="tutor_kana"><td-c>{{list.student_tutor.tutor.f_name_kana}} {{list.student_tutor.tutor.l_name_kana}}</td-c></template>
            </template>
            <template v-else>
              <td-c></td-c>
              <td-c></td-c>
            </template>
            <template v-if="month"><td-c><input type="text" v-model="list.month"></td-c></template>
            <template v-if="state">
              <td-c class="select">
                <multiselect v-model="watchPatch.state" :options="State" label="name" :show-labels="false" placeholder="現状"></multiselect>
              </td-c>
            </template>
            <template v-if="note"><td-c><textarea type="text" v-model="list.note"></textarea></td-c></template>
            <template v-if="file_name">
              <td-c class="select">
                <multiselect v-model="watchPatch.file_name" :options="fileName" label="name" :show-labels="false" placeholder="ファイル名"></multiselect>
              </td-c>
            </template>
            <template v-if="points_english"><td-c><input type="text" v-model="list.points_english"></td-c></template>
            <template v-if="points_mathematics"><td-c><input type="text" v-model="list.points_mathematics"></td-c></template>
            <template v-if="points_japanese"><td-c><input type="text" v-model="list.points_japanese"></td-c></template>
            <template v-if="points_science"><td-c><input type="text" v-model="list.points_science"></td-c></template>
            <template v-if="points_socialstudies"><td-c><input type="text" v-model="list.points_socialstudies"></td-c></template>
            <template v-if="file">
              <td-c>
                <form class="update_form" enctype="multipart/form-data">
                  <input @change="patchSelectedFile" type="file" id="file">
                </form>
              </td-c>
            </template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>

          </template>

          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteReport(list)" class="del">削除</td-c>
            <td-c @click.native="edit(list)" class="del">編集</td-c>
            <template v-if="id"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.id}}</a></template>
            <template v-if="student_tutor_id"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor_id}}</a></template>
            <template v-if="student_name"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.student.f_name}} {{list.student_tutor.student.l_name}}</a></template>
            <template v-if="student_kana"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.student.f_name_kana}} {{list.student_tutor.student.l_name_kana}}</a></template>
            <template v-if="list.tutor">
              <template v-if="tutor_name"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.tutor.f_name}} {{list.student_tutor.tutor.l_name}}</a></template>
              <template v-if="tutor_kana"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.tutor.f_name_kana}} {{list.student_tutor.tutor.l_name_kana}}</a></template>
            </template>
            <template v-else>
              <td-c></td-c>
              <td-c></td-c>
            </template>
            <template v-if="month"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.month}}</a></template>
            <template v-if="state">
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 0">未選択</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 1">提出済</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 2">連絡済</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 3">未提出</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 4">テキスト未使用</a>
            </template>
            <template v-if="note"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.note}}</a></template>
            <template v-if="file_name">
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.file_name === 0">未選択</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.file_name === 1">指導報告書</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.file_name === 2">引継文章</a>
            </template>
            <template v-if="points_english"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_english}}</a></template>
            <template v-if="points_mathematics"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_mathematics}}</a></template>
            <template v-if="points_japanese"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_japanese}}</a></template>
            <template v-if="points_science"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_science}}</a></template>
            <template v-if="points_socialstudies"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_socialstudies}}</a></template>
            <template v-if="file"><a v-bind:href="linkReport(list)" target="_blank" class="link"></a></template>
            <template v-if="user"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.user.user}}</a></template>
            <template v-if="created_at"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.created_at.substring(0, 10)}}</a></template>
          </template>

        </tr-c>
      </table-c>
    </div>
    <!-- <div style="display: flex" class="StudentReports_upload"> -->
    <!--   <form class="upload_form" method="post" enctype="multipart/form&#45;data" @submit.prevent="postReport" @keypress.stop.prevent.13> -->
    <!--     <div class="container"> -->
    <!--       <input type="text" required maxlength="7" minlength="7" class="input" v&#45;model="report.month" placeholder="0001/01"> -->
    <!--       <multiselect v&#45;model="watch.state" :options="State" label="name" :show&#45;labels="false" placeholder="現状"></multiselect> -->
    <!--       <multiselect v&#45;model="watch.file_name" :options="fileName" label="name" :show&#45;labels="false" placeholder="ファイル名"></multiselect> -->
    <!--       <div class="box"> -->
    <!--         <i class="fa fa&#45;camera"></i> -->
    <!--         <input @change="selectedFile" type="file" id="file"> -->
    <!--       </div> -->
    <!--       <btn type="submit" class="upload">アップロード</btn> -->
    <!--     </div> -->
    <!--  -->
    <!--     <div class="container"> -->
    <!--       <textarea class="note" v&#45;model="report.note" type="text" placeholder="備考"></textarea> -->
    <!--       <input type="text" class="points" v&#45;model="report.points_english" placeholder="英語"> -->
    <!--       <input type="text" class="points" v&#45;model="report.points_mathematics" placeholder="数学"> -->
    <!--       <input type="text" class="points" v&#45;model="report.points_japanese" placeholder="国語"> -->
    <!--       <input type="text" class="points" v&#45;model="report.points_science" placeholder="理科"> -->
    <!--       <input type="text" class="points" v&#45;model="report.points_socialstudies" placeholder="社会"> -->
    <!--     </div> -->
    <!--   </form> -->
    <!-- </div> -->


  </div>
</template>

<script>
import moment from 'moment'
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/reports/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  max: config.LIMIT,
  url: url,
  pageName: 'report',
  pageNames: 'reports'
}

let _ = window._
export default {
  props: {
    student: Object
  },
  computed: {
    // order By
    orderedStudent_tutors () {
      console.log(this.student)
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.student.student_tutors, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.student.student_tutors, this.sortColumn)
      }
    },

    reports () {
      return this.$store.getters.reports
    },

    filteredReports () {
      const self = this
      return self.reports.filter((report) => {
        return report.student_tutor.student_id === self.student.id
      })
    },

    // filter By
    FilteredReports () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.searchQuery) // ["id", "student_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.searchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.orderedReports // 全部返す
      }
      // isSearch じゃなければfilterする
      return self.orderedReports.filter((el) => {
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.searchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return flg
      })
    },

    notFilteredReports () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.notSearchQuery) // ["id", "student_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.notSearchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.FilteredReports // 全部返す FilteredContractsを返す
      }
      // isSearch じゃなければfilterする
      return self.FilteredReports.filter((el) => { // FilteredReportsにfilterをかける
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.notSearchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return !flg // 反転
      })
    }
  },
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      sortState: '降順',
      sortColumn: 'month',
      searchType: '',

      id: true,
      student_name: true,
      student_kana: true,
      tutor_name: true,
      tutor_kana: true,
      student_tutor_id: false,
      user: false,
      month: true,
      state: true,
      note: true,
      file_name: true,
      points_english: true,
      points_mathematics: true,
      points_japanese: true,
      points_science: true,
      points_socialstudies: true,
      file: true,
      created_at: true,

      // search params
      searchQuery: {
        id: '',
        student_tutor_id: '',
        student_name: '',
        student_kana: '',
        tutor_name: '',
        tutor_kana: '',
        user: '',
        month: '',
        state: '',
        note: '',
        file_name: '',
        points_english: '',
        points_mathematics: '',
        points_japanese: '',
        points_science: '',
        points_socialstudies: '',
        created_at: ''
      },

      notSearchQuery: {
        id: '',
        student_tutor_id: '',
        student_name: '',
        student_kana: '',
        tutor_name: '',
        tutor_kana: '',
        user: '',
        month: '',
        state: '',
        note: '',
        file_name: '',
        points_english: '',
        points_mathematics: '',
        points_japanese: '',
        points_science: '',
        points_socialstudies: '',
        created_at: ''
      },

      watchSearch: {
        state: '',
        file_name: '',
        not_state: '',
        not_file_name: ''
      },

      // post params
      report: {
        month: '',
        state: '',
        filing_date: moment().format('YYYY/MM/DD'), // 表示していない一応投げてる
        note: '',
        file_name: '',
        points_english: '',
        points_mathematics: '',
        points_japanese: '',
        points_science: '',
        points_socialstudies: '',
        file: ''
      },

      watch: {
        file_name: '',
        state: ''
      },

      // patch params
      PatchReport: {
        state: '',
        file_name: '',
        file: ''
      },

      watchPatch: {
        state: '',
        file_name: ''
      },

      fileName: [
        { name: '未選択', value: 0 },
        { name: '指導報告書', value: 1 },
        { name: '引継文章', value: 2 }
      ],

      State: [
        { name: '未選択', value: 0 },
        { name: '提出済', value: 1 },
        { name: '連絡済', value: 2 },
        { name: '未提出', value: 3 },
        { name: 'テキスト未使用', value: 4 }
      ]
    }
  },
  watch: {
    'watch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.report.state = now.value
      } else {
        this.report.state = ''
      }
    },

    'watchSearch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.searchQuery.state = now.value
      } else {
        this.searchQuery.state = ''
      }
    },

    'watchSearch.not_state': function (now, old) {
      // console.log(now)
      if (now) {
        this.notSearchQuery.state = now.value
      } else {
        this.notSearchQuery.state = ''
      }
    },

    'watchPatch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.PatchReport.state = now.value
      } else {
        this.PatchReport.state = ''
      }
    },

    'watch.file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.report.file_name = now.value
      } else {
        this.report.file_name = ''
      }
    },

    'watchSearch.file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.searchQuery.file_name = now.value
      } else {
        this.searchQuery.file_name = ''
      }
    },

    'watchSearch.not_file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.notSearchQuery.file_name = now.value
      } else {
        this.notSearchQuery.file_name = ''
      }
    },

    'watchPatch.file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.PatchReport.file_name = now.value
      } else {
        this.PatchReport.file_name = ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getReports(to.params.id)
    })
  },
  methods: {
    getReports (id) {
      this.$store.dispatch('getReports', id)
    },

    linkReport (list) {
      let URL = config['production'].url
      if (process.env.NODE_ENV === 'development') {
        URL = 'http://localhost:8080'
      }
      let link = URL + '#/studentreports/' + list.id
      return link
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.student_tutor_id = false
      this.student_name = false
      this.student_kana = false
      this.tutor_name = false
      this.tutor_kana = false
      this.user = false
      this.month = false
      this.state = false
      this.note = false
      this.file_name = false
      this.points_english = false
      this.points_mathematics = false
      this.points_japanese = false
      this.points_science = false
      this.points_socialstudies = false
      this.file = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.student_tutor_id = true
      this.student_name = true
      this.student_kana = true
      this.tutor_name = true
      this.tutor_kana = true
      this.user = true
      this.month = true
      this.state = true
      this.note = true
      this.file_name = true
      this.points_english = true
      this.points_mathematics = true
      this.points_japanese = true
      this.points_science = true
      this.points_socialstudies = true
      this.file = true
      this.created_at = true
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    // searchTable (e) {
    //   this.$store.dispatch('SEARCH', {
    //     this: this,
    //     e: e,
    //     obj: obj
    //   })
    // },

    edit (list) {
      this.edit_id.edit_id = list.id
      this.watchPatch.file_name = this.fileName[list.file_name]
      this.watchPatch.state = this.State[list.state]
    },

    selectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.report.file = files[0]
    },

    patchSelectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.PatchReport.file = files[0]
    },

    postReport () {
      this.$store.dispatch('postReport', {
        this: this,
        report: this.report
      })
    },

    deleteReport (list) {
      this.$store.dispatch('deleteReport', {
        this: this,
        list: list
      })
    },

    cancelReport (list) {
      this.$store.dispatch('cancelReport', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchReport (list) {
      this.$store.dispatch('patchReport', {
        this: this,
        list: list,
        edit_id: this.edit_id,
        report: this.PatchReport
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.link {
  text-decoration: none;
  display: table-cell;
  vertical-align: middle;
  border-bottom: solid 1px #ccc;
  border-right: solid 1px #ccc;
  padding: .5rem;
}

.index-box {
  height: calc(100vh - 280px);
  overflow: scroll;
  margin-top: 10px;
}

.upload_form {
  .container {
    display: flex;
    .input {
      border: solid 1px #ccc;
      width: 150px;
      height: 36px;
      padding: 10px;
    }
    .points {
      border: solid 1px #ccc;
      width: 100px;
      height: 36px;
      padding: 10px;
    }
    .note {
      height: 36px;
      min-width: 400px;
      border: solid 1px #ccc;
    }
    .box {
      position: relative;
      .fa-camera {
        color: #ccc;
        font-size: 25px;
        padding: 7px;
        height: 36px;
        position: absolute;
        top: 0;
      }
      width: 100%;
      input[type="file"] {
        height: 36px;
        -webkit-appearance: none;
        appearance: none;
        border: solid 1px #ccc;
        width: 100%;
      }
      input[type="file"]::-webkit-file-upload-button {
        width: 36px;
        height: 36px;
        opacity: 0;
        -webkit-appearance: none;
        appearance: none;
      }
    }
  }
}

.upload {
  border: solid 1px #37474F;
  height: 36px;
  min-width: 120px;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
  background: #37474F;
  color: #fff;
}

.update_form {
}

.list-edit {
  .td {
    padding: 0 5px 0 5px;
    input {
      height: 23px;
      width: 100%;
    }
    textarea {
      height: 23px;
      width: 100%;
      outline: 0;
      border: none;
    }
  }
}

.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}

.slideActive {
  background: #455A64;
  color: #fff;
}

.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}

.resetSearch {
  padding: 7px 0;
}

.table {
  margin-top: 0 !important;
}

.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}

.th {
  cursor: pointer;
  min-width: 60px;
}

.select {
  padding: 0 !important;
}

input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
}

.del {
  text-align: center;
  cursor: pointer;
  width: 80px;
  &:hover {
    background: black;
    color: white;
  }
}
</style>

<style lang="scss">
.StudentReports {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    // margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>

<style lang="scss">
.StudentReports_upload {
  .multiselect {
    min-height: 34px;
    min-width: 100px;
  }

  .multiselect__tags {
    border: solid 1px #ccc;
    border-radius: 0;
    min-height: 34px;
    padding: 0px 40px 0 2px;
  }

  .multiselect__tags-wrap {
    background: red;
  }

  .multiselect__input {
    margin-bottom: 0;
    height: 34px;
  }

  .multiselect__select {
    height: 34px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }

  .multiselect__single {
    margin-top: 7px;
    margin-bottom: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// StudentReports.vue?42033b8e